/**
 * @file Album Folder Tag related constants.
 */

import { IDENTITY_GENDER } from './identity';

/**
 * Album folder tag type enum.
 *
 * @enum ALBUM_FOLDER_TAG_TYPE
 * @type {{UNIFORM: string, GRADE: string}}
 */
const ALBUM_FOLDER_TAG_TYPE = {
  UNIFORM: 'UNIFORM',
  GRADE: 'GRADE',
  CUSTOM: 'CUSTOM',
  CLASS: 'CLASS',
};

/**
 * Album folder tag gender enum.
 *
 * @enum ALBUM_FOLDER_TAG_GENDER
 * @type {{MALE: string, FEMALE: string, ALL: null}}
 */
const ALBUM_FOLDER_TAG_GENDER = {
  MALE: IDENTITY_GENDER.MALE,
  FEMALE: IDENTITY_GENDER.FEMALE,
  ALL: null,
};

/**
 * Album folder gender tag label enum.
 *
 * @enum ALBUM_FOLDER_GENDER_TAG_LABEL
 * @type {{MALE: string, FEMALE: string, ALL: string}}
 */
const ALBUM_FOLDER_GENDER_TAG_LABEL = {
  [ALBUM_FOLDER_TAG_GENDER.MALE]: 'Boys',
  [ALBUM_FOLDER_TAG_GENDER.FEMALE]: 'Girls',
  [ALBUM_FOLDER_TAG_GENDER.ALL]: 'Co-Ed',
};

/**
 * Album Folder Tag Search Constants.
 *
 * @enum ALBUM_FOLDER_GENDER_TAG_LABEL
 * @type {{ANY: string, ALL: string}}
 */
const ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE = {
  ALL: 'ALL',
  ANY: 'ANY',
  NONE: 'NONE',
};

/**
 * Jersey Color Constants.
 *
 * @enum ALBUM_FOLDER_UNIFORM_TAG_JERSEY_COLOR
 */
const ALBUM_FOLDER_UNIFORM_TAG_JERSEY_COLOR = {
  RED: 'red',
  GREEN: 'green',
  BLUE: 'blue',
  ORANGE: 'orange',
  YELLOW: 'yellow',
  PURPLE: 'purple',
  BLACK: 'black',
  GRAY: 'gray',
  WHITE: 'white',
};

/**
 * Game venue types.
 *
 * @enum ALBUM_SPORTS_GAME_VENUE_TYPE
 * @type {{HOME: string, AWAY: string}}
 */
const ALBUM_SPORTS_GAME_VENUE_TYPE = {
  HOME: 'HOME',
  AWAY: 'AWAY',
};

export {
  ALBUM_FOLDER_TAG_TYPE,
  ALBUM_FOLDER_TAG_GENDER,
  ALBUM_FOLDER_GENDER_TAG_LABEL,
  ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE,
  ALBUM_FOLDER_UNIFORM_TAG_JERSEY_COLOR,
  ALBUM_SPORTS_GAME_VENUE_TYPE,
};
